<div class="filter-container">
  <div class="filter-window">
    <div class="row">
      <div class="form-container col-12">
        <form [formGroup]="blankReceiptForm" class="row col-12">
          <div class="col-12 col-md-6">
            <div class="cell col-12 form-group row" *ngIf="customers && showSelectCustomers">
              <eps-select
                [options]="customers"
                (ngModelChange)="customerSelectionChanged()"
                label="ORDERS.FILTER.LABELS.CUSTOMERS"
                formControlName="customerId"
                autoSelect
                [showErrors]="false"
              ></eps-select>
            </div>
            <div class="cell col-12 form-group row">
              <eps-select
                [options]="shipTos"
                [busy]="shipTosLoading"
                [disabled]="isSaving || (shipTos?.length <= 1)"
                label="BLANK_RECEIPT.SHIP_TOS"
                formControlName="shipToId"
                autoSelect
                [showErrors]="false"
              ></eps-select>
            </div>
            <div class="cell col-12 form-group row">
              <eps-radio-group
                [options]="receiptTypes"
                [busy]="shipTosLoading"
                [disabled]="isSaving || (shipTos?.length <= 1)"
                label="BLANK_RECEIPT.RECEIPT_TYPE"
                formControlName="type"
                [showErrors]="false"
                autoSelect
              ></eps-radio-group>
            </div>
            <div class="cell col-12 form-group row">
              <eps-number-input
                label="BLANK_RECEIPT.QUANTITY"
                formControlName="quantity"
                [showErrors]="false"
              ></eps-number-input>
            </div>

          </div>
        </form>
        <div class="end-xs">
          <eps-button
            type="primary"
            [disabled]="blankReceiptForm.invalid"
            [busy]="isSaving"
            buttonIcon="plus-square"
            (buttonClick)="createReceipts()"
            label="BLANK_RECEIPT.CREATE_RECEIPT"
            submit
            ></eps-button>
        </div>
      </div>
    </div>
  </div>
</div>
